import(/* webpackMode: "eager" */ "/opt/build/repo/app/news/page.tsx");
